import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./navbarStyle.css";
import "aos/dist/aos.css";
import Cookies from "js-cookie";

export default function Navbar() {
    const navigate = useNavigate();

    const [state, setState] = useState(false);
    const [showLogout, setShowLogout] = useState(false);

    useEffect(() => {
        if (Cookies.get("token") !== undefined) {
            setShowLogout(true);
        } else {
            setShowLogout(false);
        }
    }, []);

    function changeState() {
        if (state) {
            setState(false);
        } else {
            setState(true);
        }
    }

    function switchSide(side) {
        navigate(side);
    }

    function logout() {
        Cookies.remove("token");
        localStorage.removeItem("id");
        localStorage.removeItem("username");
        localStorage.removeItem("role");
        navigate("/login");
    }

    function isEasterPeriod() {
        const today = new Date();

        return today.getMonth() === 3 && today.getDate() >= 1 && today.getDate <= 30;
    }

    function isChristmasPeriod() {
        const today = new Date();

        return today.getMonth() === 11 && today.getDate() >= 1 && today.getDate <= 31;
    }

    return (
        <div className="navbarContainer">
            <div className="navbar">
                <img src={isEasterPeriod ? "/img/logo_ostern.png" : isChristmasPeriod ? "/img/logo_weihnachten.png" : "/img/logo.png"} />
                <div className="textContainer">
                    <h1 onClick={() => switchSide("/")}>Startseite</h1>
                    <h1 onClick={() => switchSide("/events")}>Events</h1>
                    <h1 onClick={() => switchSide("/bio")}>Bio<span className="ref"> & Referenzen</span></h1>
                    <h1 onClick={() => switchSide("/galerie")}>Galerie</h1>
                    <h1 onClick={() => switchSide("/technik")}>Technik</h1>
                    <h1 onClick={() => switchSide("/tipps")}>Tipps</h1>
                    <h1 onClick={() => switchSide("/anfrage")}>Booking</h1>
                </div>
                <button onClick={() => switchSide("/login")}>Login</button>
            </div>
            <img
                id="menu"
                src="/img/menu.svg"
                onClick={changeState}
                style={{
                    transition: "0.2s",
                    transform: state ? "rotate(-20deg)" : "rotate(0deg)"
                }}
            />
            {state && (
                <div className="navbarMenu">
                    <h1 onClick={() => switchSide("/")}>Startseite</h1>
                    <h1 onClick={() => switchSide("/events")}>Events</h1>
                    <h1 onClick={() => switchSide("/bio")}>Bio & Referenzen</h1>
                    <h1 onClick={() => switchSide("/galerie")}>Galerie</h1>
                    <h1 onClick={() => switchSide("/technik")}>Technik</h1>
                    <h1 onClick={() => switchSide("/tipps")}>Tipps</h1>
                    <h1 onClick={() => switchSide("/anfrage")}>Booking</h1>
                    <h1 onClick={() => switchSide("/login")}>Musikwunsch</h1>
                    {showLogout && (
                        <h1 onClick={() => logout()}>Logout</h1>
                    )}
                </div>
            )}
        </div>
    )
}
